<template>
    <div>
        <div class="modal fade" id="mdpedidosprodutos" tabindex="-1" role="dialog" aria-labelledby="mdpedidosprodutos" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"><i class="fa fa-cubes"></i> Pedidos de compra  do produto</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row" v-show="mostrar">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{idproduto}} - {{ descproduto }}</span>
                                </div>                                                                
                            </div>
                            <div v-if="lstprodutos.length > 0" class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover">
                                        <thead class="thead-light">
                                            <tr style="font-weight: 600;">
                                                <th>N. pedido:</th>
                                                <th>Fornecedor:</th>
                                                <th>Emissão:</th> 
                                                <th>Entrega:</th>
                                                <th>Qtd:</th>
                                                <th>Und:</th>
                                                <th>Dias entrega:</th>
                                                <th>Atraso:</th>
                                                <th>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in lstprodutos" v-bind:key="index">
                                                <td>{{ item.id }}</td>
                                                <td>{{item.fantasia}}</td>
                                                <td>{{item.dtemissao}}</td> 
                                                <td>{{item.dtentrega}}</td>
                                                <td>{{item.qtd}}</td>
                                                <td>{{item.und}}</td>
                                                <td>{{item.diasentrega}}</td>
                                                <td>{{item.diasatraso}}</td>
                                                <td>
                                                    <span v-if="parseInt(item.situacao)=== 0"     class="badge badge-pill badge-primary bdg-digitacao" style="">Em digitação</span>
                                                    <span v-else class="badge badge-pill badge-primary bdg-aguardando">Aguardando</span>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else class="col-md-12" style="padding-bottom: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item lst-item-estoque text-center">
                                        <span>
                                            SEM PRODUTOS PARA VISUALIZAÇÃO
                                        </span>
                                    </li>
                                </ul>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-sign-out"></i> Fechar</a>
                    </div>
                </div>
            </div>
        </div>                
    </div>
</template>
<script>
import util from '../utilitarios/util.js'

export default {
    name: 'cmppedidosprodutos',

    props:[
                'idproduto',
               'descproduto'
          ],
    data: function() {
        return {

            mostrar             : false,//variável só pra esconder a visualização da div
            lstprodutos         : [],
            disponivel          : 0,
          
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },        
        mtdlistarprodutos(){
            let vself       = this;
            let loader      = vself.$loading.show();
            let parametros  = [
                {parametro: 'op',               valor : 'listarpedidocompra'},
                {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idproduto',        valor : vself.idproduto},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
            retorno.then(function (response) {
                loader.hide();
                vself.lstprodutos = response.data;
                    
                vself.mostrar     = true;  
            }).catch(function (response) {
                vself.mostrar     = false;  
                loader.hide();
            });
        },        
         
    },
    mounted: function() {
        let vself = this;
        $("#mdpedidosprodutos").on('shown.bs.modal', function(){
            vself.mtdlistarprodutos();
        });
        $("#mdpedidosprodutos").on('hide.bs.modal', function(){
            vself.mostrar     = false;
            vself.lstprodutos = [];
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
    .lst-item-estoque{
        padding: 5px 15px !important;
        font-weight: 700;
        color: #666666;
    }
    .badge-item-estoque{
        font-size: 14px!important;
    }
    #mdpedidosprodutos{
        z-index: 2001!important;
    } 
    .btn-visualiza-reserva{
        cursor: pointer;
        float: left;
        margin-top: 5px; 
        transition: 0.2s;       
    } 
    .btn-visualiza-reserva:hover{
        filter: brightness(90%)!important;
        transition: 0.2s;       
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-aguardando{
        background: #EEA435!important;
        color: white;
    }             
</style>